// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ButtonHighlight.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module Button Highlight component
 * @example
 *  <ButtonHighlight value={false} states={[{value: val-state, icon: 'sate-icon'}]} description={''} onClick={} />
 */

import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { get, getOr, find, omit, findIndex, isFunction, first } from 'lodash/fp';
const DEFAULT_INDEX = 0;
const NEXT_INDEX = 1;

@observer
export default class ButtonHighlight extends Component {
  static propTypes = {
    description: PropTypes.string,
    states: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func
  };

  static defaultProps = {
    states: [],
    onClick: null,
    description: ''
  };

  onClick = () => {
    const { propertyKey, value, loadValue, states, loadStates, onChange, beforeOnChange } = this.props;
    const stateList = isFunction(loadStates) ? loadStates() : states;
    const val = isFunction(loadValue) ? get(propertyKey, loadValue()) : value;
    let currentState = findIndex(item => item.value === val, stateList);

    if (currentState < 0) {
      currentState = NEXT_INDEX;
    } else if (currentState >= stateList.length - 1) {
      currentState = DEFAULT_INDEX;
    } else {
      currentState++;
    }
    var newArgs = [
      {
        value: stateList[currentState].value
      }
    ];
    var applyOnChange = updateParam => {
      newArgs = updateParam || newArgs;
      onChange && onChange.apply(null, newArgs);
    };

    if (beforeOnChange) {
      beforeOnChange.apply(this, newArgs).then(applyOnChange);
    } else {
      applyOnChange();
    }
  };

  render() {
    const { propertyKey, value, loadValue, className, states, loadStates, defaultIcon, description } = this.props;
    const val = isFunction(loadValue) ? get(propertyKey, loadValue()) : value;
    const classes = classnames(className, 'btn-highlight', {
      active: val
    });
    const stateList = isFunction(loadStates) ? loadStates() : states;
    const current = find(item => item.value === val, stateList) || first(stateList);
    const icon = getOr(defaultIcon, 'icon', current);
    const rest = omit(
      [
        'states',
        'description',
        'onClick',
        'keyPath',
        'disabledIcon',
        'beforeOnChange',
        'hiddenByState',
        'loadValue',
        'propertyKey',
        'defaultIcon',
        'showInactiveState',
        'loadStates'
      ],
      this.props
    );
    return (
      <button {...rest} value={val} className={classes} title={description} onClick={this.onClick}>
        <span className={icon} value={val} />
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ButtonHighlight.js